import { Navigate, useLocation } from "react-router-dom"

import { useAuth } from "@/contexts/auth-context"
import { useUser } from "@/contexts/user-context"
import { LoadingFallback } from "@/routes/guards/loading-fallback"

const AUTH_BYPASS_PATHS = new Set([
  "/auth/callback",
])

export function AccessGate({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()
  const { accessChecked, hasAccess } = useUser()
  const location = useLocation()

  if (AUTH_BYPASS_PATHS.has(location.pathname)) {
    return <>{children}</>
  }

  if (isLoading) {
    return <LoadingFallback />
  }

  if (!isAuthenticated) {
    return <>{children}</>
  }

  if (!accessChecked) {
    return <LoadingFallback />
  }

  // No roles: only /no-access is allowed
  if (!hasAccess) {
    if (location.pathname === "/no-access") {
      return <>{children}</>
    }
    return <Navigate to="/no-access" replace />
  }

  // Has roles: don't let them sit on /no-access
  if (location.pathname === "/no-access") {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
